import ElectronicPrescriptionApi from '@modules/admin/electronicPrescription/electronicPrescription.Api'
import Axios from 'axios'

import { refreshTokenInterceptor } from '@services/APIInterceptors/refreshTokenInterceptors'

class ElectronicPrescriptionSigleton {
  constructor() {
    const httpConfig = {
      baseURL: import.meta.env.VITE_REACT_APP_URL_ELECTRONIC_PRESCRIPTION,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    this.client = Axios.create(httpConfig)
    console.info(`Axios instance CONSUTATIONS: ${this.client.defaults.baseURL}`)

    this.client.interceptors.request.use(refreshTokenInterceptor)

    //ADMIN CALLS
    this.prescription = new ElectronicPrescriptionApi(this.client, 'external/v1/admin/customer')
  }

  static get instance() {
    return this._instance || (this._instance = new this())
  }

  updateHeaders(headerLines) {
    this.client.defaults.headers.common = {
      ...this.client.defaults.headers.common,
      ...headerLines,
    }
  }

  // sets the default headers
  removeHeaders() {
    this.client.defaults.headers.common = {
      Accept: 'application/json',
    }
  }
}

const ElectronicPrescriptions = ElectronicPrescriptionSigleton.instance
export default ElectronicPrescriptions
